import { ArrowRight, BarChart3, LogOut, ShieldCheck, ShieldOff } from 'lucide-react';
import { useState, type FormEvent } from 'react';

interface UsageAnalyticsChoiceScreenProps {
  email: string;
  onChoose: (sharingEnabled: boolean) => Promise<void>;
  onSignOut: () => void;
}

export function UsageAnalyticsChoiceScreen({ email, onChoose, onSignOut }: UsageAnalyticsChoiceScreenProps) {
  const [choice, setChoice] = useState<'share' | 'private' | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!choice) {
      setError('กรุณาเลือกว่าต้องการแชร์สถิติหรือไม่');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await onChoose(choice === 'share');
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'บันทึกตัวเลือกไม่สำเร็จ กรุณาลองใหม่');
      setBusy(false);
    }
  };

  return <main className="usage-choice-shell">
    <header className="usage-choice-header">
      <div className="auth-brand"><span>BF</span><strong>BilaFlow</strong></div>
      <div><span>{email}</span><button type="button" onClick={onSignOut}><LogOut size={15} /> ออกจากระบบ</button></div>
    </header>
    <form className="usage-choice-card" onSubmit={submit}>
      <div className="usage-choice-intro">
        <div className="usage-choice-icon"><ShieldCheck size={29} /></div>
        <span className="eyebrow">ตั้งค่าความเป็นส่วนตัวครั้งแรก</span>
        <h1>เลือกก่อนเริ่มใช้งาน</h1>
        <p>กรุณาเลือกว่าต้องการแชร์สถิติจำนวนรวมเพื่อช่วยพัฒนา BilaFlow หรือไม่ คุณจะไปขั้นตอนถัดไปได้หลังบันทึกตัวเลือก</p>
      </div>

      <fieldset className="usage-choice-options">
        <legend>ตัวเลือกการแชร์สถิติ</legend>
        <label className={choice === 'share' ? 'selected' : ''}>
          <input type="radio" name="usage-choice" value="share" checked={choice === 'share'} onChange={() => setChoice('share')} />
          <span className="usage-choice-option-icon share"><BarChart3 size={20} /></span>
          <span><strong>แชร์สถิติจำนวนรวม</strong><small>ส่งจำนวน QT, Invoice, Receipt วันที่ใช้งานล่าสุด และเวอร์ชันแอป</small></span>
        </label>
        <label className={choice === 'private' ? 'selected' : ''}>
          <input type="radio" name="usage-choice" value="private" checked={choice === 'private'} onChange={() => setChoice('private')} />
          <span className="usage-choice-option-icon private"><ShieldOff size={20} /></span>
          <span><strong>ไม่แชร์สถิติ</strong><small>ระบบจะไม่ส่งจำนวนเอกสาร และจะแจ้งสถานะว่าไม่ได้แชร์เท่านั้น</small></span>
        </label>
      </fieldset>

      <div className="usage-choice-boundary"><ShieldCheck size={17} /><p><strong>ไม่ว่าคุณจะเลือกแบบใด</strong> ระบบจะไม่ส่งเลขที่เอกสาร ชื่อลูกค้า ยอดเงิน รายการสินค้า หมายเหตุ สลิป หรือไฟล์แนบ และเปลี่ยนตัวเลือกภายหลังได้ในหน้าตั้งค่า</p></div>
      <p className="usage-choice-policy">ดูรายละเอียดใน <a href="/privacy.html" target="_blank" rel="noreferrer">นโยบายความเป็นส่วนตัว</a></p>
      {error && <p className="auth-error" role="alert">{error}</p>}
      <button className="btn primary usage-choice-submit" disabled={!choice || busy}>{busy ? 'กำลังบันทึก…' : 'บันทึกและไปต่อ'} <ArrowRight size={17} /></button>
    </form>
  </main>;
}
